// 季節状態 (seasonal_status) のラベル/色定義
export const SEASONAL_STATUS_OPTIONS = [
  {
    value: "in_season",
    label: "今が旬",
    badgeClass: "bg-emerald-100 text-emerald-700 border-emerald-300",
    pillClass: "bg-emerald-600 text-white",
  },
  {
    value: "ending_soon",
    label: "まもなく終了",
    badgeClass: "bg-amber-100 text-amber-700 border-amber-300",
    pillClass: "bg-amber-500 text-white",
  },
  {
    value: "ended",
    label: "終了",
    badgeClass: "bg-slate-200 text-slate-700 border-slate-300",
    pillClass: "bg-slate-500 text-white",
  },
  {
    value: "out_of_stock",
    label: "入荷なし",
    badgeClass: "bg-red-100 text-red-700 border-red-300",
    pillClass: "bg-red-600 text-white",
  },
];

export const getSeasonalStatusOption = (status) =>
  SEASONAL_STATUS_OPTIONS.find((o) => o.value === status) || null;

// 一覧から非表示にする条件
export const isHiddenProduct = (product) => {
  if (!product) return false;
  if (product.is_out_of_stock) return true;
  if (product.seasonal_status === "out_of_stock") return true;
  return false;
};

// 店舗発注画面から非表示にする条件（在庫なしのみ）
export const isHiddenFromStore = (product) => {
  if (!product) return false;
  if (isHiddenProduct(product)) return true;
  // 価格0円の商品も表示する（やさまるDesk同期商品には価格がない場合がある）
  return false;
};
